import ProfileRequestCard from "./ProfileRequestCard";

const NewRequest = () => {
  return (
    <div className="flex flex-col justify-start items-center w-full overflow-x-hidden">
      <ProfileRequestCard />
      <ProfileRequestCard />
      <ProfileRequestCard />
      <ProfileRequestCard />
    </div>
  );
};
export default NewRequest;
